import { render } from "./HkRetails.vue?vue&type=template&id=9016ca76&scoped=true"
import script from "./HkRetails.vue?vue&type=script&lang=js"
export * from "./HkRetails.vue?vue&type=script&lang=js"

import "./HkRetails.vue?vue&type=style&index=0&id=9016ca76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9016ca76"]])

export default __exports__